/* Tysk katalog for locale-payroll-runs-no.js (del 1 av 2).
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('de', {
  'pay.overview': 'Lohnübersicht',
  'pay.overviewSub': 'Erfasster Lohn für das Geschäftsjahr, gruppiert nach Mitarbeitenden.',
  'pay.noPayBasis': 'Noch keine Lohngrundlage',
  'pay.noPayBasisHint': 'Sobald Lohnläufe genehmigt oder ausgezahlt sind, erscheint die Übersicht hier.',
  'pay.noPeriodsHint': 'Arbeitgeberabgabe und Lohnsteuerabzug werden angezeigt, sobald du genehmigte Lohnläufe hast.',
  'pay.noOtpBasisHint': 'Die Pensionsgrundlage wird angezeigt, sobald du Lohnläufe mit Pensionsbeträgen hast.',
  'pay.noHolidayPayHint': 'Die Urlaubsgeldgrundlage wird angezeigt, sobald du im gewählten Zeitraum genehmigte Lohnläufe hast.',
  'pay.noPayslipsHint': 'Lohnabrechnungen werden angezeigt, sobald der Lohnlauf Mitarbeitende enthält.',
  'pay.noInboxVouchersHint': 'Belege, die noch nicht gebucht sind, werden hier angezeigt.',
  'pay.noEntriesHint': 'Buchungsbelege werden angezeigt, nachdem der Lohnlauf genehmigt wurde.',
  'pay.noFixedLinesHint': 'Lege feste Lohnzeilen bei Mitarbeitenden an, um sie im Lohnlauf zu verwenden.',
  'pay.salaryTypeSearchHintFull': 'Häufige Lohnarten werden zuerst angezeigt. Suche oder wähle „Mehr anzeigen“ für den gesamten aktiven Katalog.',
  'pay.overrideReasonSavedOnLineHint': 'Wird als Prüfpfad in der Lohnzeile gespeichert.',
  'pay.salaryTypeSearchHintRest': 'Häufige Lohnarten werden zuerst angezeigt. Suche oder wähle „Mehr anzeigen“ für den Rest.',
  'pay.overrideReasonSavedOnFixedLineHint': 'Wird in der festen Zeile gespeichert.',
  'pay.payPeriodMonthOnlyHint': 'Lohnläufe unterstützen vorerst nur Monatszeiträume.',
  'pay.calculationCodeOtherHint': 'Weitere Berechnungscodes werden verfügbar, sobald sie implementiert und geprüft sind.',
  'pay.runsAndEmployeesInline': '{{runs}} Lohnl. · {{employees}} Mitarbeitende',
  'pay.fteShort': 'VZÄ:',
  'pay.taxShort': 'Steuer:',
  'pay.netShort': 'Netto:',
  'pay.holidayPayShort': 'Urlaubsg.:',
  'pay.agaShort': 'AGA:',
  'pay.withholdingHelp': 'Lohnsteuerabzug — die Steuer, die vom Bruttolohn abgezogen und im Namen der Mitarbeitenden an den Staat gezahlt wird.',
  'pay.holidayPayHelp': 'Erworbenes Urlaubsgeld — normalerweise 10,2 % der Lohngrundlage. Wird im Jahr nach dem Erwerb ausgezahlt.',
  'pay.aga': 'AGA',
  'pay.agaHelp': 'Arbeitgeberabgabe auf den Lohn — eine Abgabe, die der Arbeitgeber zusätzlich zu den Lohnkosten an den Staat zahlt.',
  'pay.fpShort': 'UG:',
  'pay.agaOfHolidayPay': 'AGA auf UG',
  'pay.agaOfHolidayPayHelp': 'Arbeitgeberabgabe, berechnet auf das erworbene Urlaubsgeld. Wird zurückgestellt, wenn das Urlaubsgeld erworben wird.',
  'pay.fte': 'Vollzeitäquivalente',
  'pay.fteHelp': 'Stellenanteil umgerechnet in volle Vollzeitäquivalente. 1,00 = volle Stelle, 0,50 = halbe Stelle.',
  'pay.overviewFilteredSub': 'Erfasster Lohn für das Geschäftsjahr, gefiltert nach Auszahlungsdatum.',
  'pay.grouping': 'Gruppierung',
  'pay.perEmployee': 'Pro Mitarbeitendem',
  'pay.perSalaryType': 'Pro Lohnart',
  'pay.employeeAndType': 'Mitarbeitende und Lohnart',
  'pay.againstWithholding': 'Gegen Lohnsteuerabzug',
  'pay.againstAga': 'Gegen AGA',
  'pay.postedAs': 'Wird so gebucht:',
  'pay.postedWithholdingOnly': '{{tax}} gegen 2600 Lohnsteuerabzug. Offen vor Zahlung: {{openTax}}.',
  'pay.postedAgaOnly': '{{aga}} gegen 2770 Arbeitgeberabgabe. Offen vor Zahlung: {{openAga}}.',
  'pay.postedBoth': '{{tax}} gegen 2600 Lohnsteuerabzug und {{aga}} gegen 2770 Arbeitgeberabgabe. Offen vor Zahlung: {{openTax}} Steuer und {{openAga}} AGA.',
  'pay.autoPostedAgainstWithholding': 'Die Zahlung wird automatisch gegen 2600 Lohnsteuerabzug gebucht und dem gewählten Verrechnungskonto gutgeschrieben.',
  'pay.autoPostedAgainstAga': 'Die Zahlung wird automatisch gegen 2770 Arbeitgeberabgabe gebucht und dem gewählten Verrechnungskonto gutgeschrieben.',
  'pay.autoPostedAgainstBoth': 'Die Zahlung wird automatisch gegen 2600 Lohnsteuerabzug und 2770 Arbeitgeberabgabe gebucht und dem gewählten Verrechnungskonto gutgeschrieben.',
  'pay.agreedAnnualSalary': 'Vereinbartes Jahresgehalt',
  'pay.agreedHourlyPay': 'Vereinbarter Stundenlohn',
  'pay.withholdingSeparatePaymentNote': 'Der Lohnsteuerabzug für ab 2026 ausgezahlten Lohn wird separat gezahlt, spätestens am ersten Werktag nach der Lohnauszahlung.',
  'pay.recommendedForOtpPayment': 'Empfohlen für OTP-Zahlung',
  'pay.otpPaymentPostingNote': 'Die Zahlung wird gegen das gewählte Verrechnungskonto gebucht und von der Pension/OTP-Übersicht verwendet. Die Bankzeile kann anschließend mit dem Zahlungsbeleg abgeglichen werden.',
  'pay.holidayPayAccruedLastYear': 'Urlaubsgeld, im Vorjahr erworben',
  'pay.holidayPayAccruedThisYear': 'Urlaubsgeld, in diesem Jahr erworben',
  'pay.ordinaryEmployment': 'Ordentliches Arbeitsverhältnis',
  'pay.payslipUncheckAllNote': 'Entferne das Häkchen für alle Mitarbeitenden, wenn die Lohnabrechnungen später gesendet werden sollen. Sie können aus dem Lohnlauf gesendet werden, nachdem die Buchung genehmigt wurde.',
  'pay.payslipPdfNotConnected': 'Das Lohnabrechnungs-PDF ist nicht mit dem Backend verbunden.',
  'pay.noSalaryLines': 'Keine Lohnzeilen',
  'pay.deletedOn': 'Gelöscht {{date}}',
  'pay.payrollPaymentOn': 'Lohnauszahlung {{date}}',
  'pay.readyLinesForPayroll': '{{count}} genehmigte Zeilen bereit für den Lohn ({{amount}}).',
  'pay.noReadyLinesForPayroll': 'Keine genehmigten Zeilen bereit für den Lohn.',
  'pay.overrideAppliesFutureRuns': 'Die Übersteuerung gilt für künftige Lohnläufe, die diese feste Zeile verwenden.',
  'pay.sentToLabel': 'wird gesendet an',
  'pay.recommendedForPayrollPayment': 'Empfohlen für die Lohnauszahlung',
  'pay.optionalNotePh': 'Optionale Notiz ...',
  'pay.openWithholding': 'Offener Lohnsteuerabzug',
  'pay.openAga': 'Offene Arbeitgeberabgabe',
  'pay.noPeriodPayments': 'Für den Zeitraum sind noch keine Zahlungen erfasst.',
  'pay.advance': 'Vorschuss',
  'pay.agaAndWithholding': 'Arbeitgeberabgabe und Lohnsteuerabzug',
  'pay.agaAndWithholdingSub': 'Verfolge Lohnsteuerabzug und Arbeitgeberabgabe aus genehmigten Lohnläufen pro Zeitraum.',
  'pay.withholdingLongHelp': 'Die Steuer, die du vom Lohn der Mitarbeitenden abgezogen hast. Sie wird auf dem Steuerabzugskonto einbehalten und an den Staat weitergeleitet — sie steht dir nicht zur Verfügung.',
  'pay.agaLongHelp': 'Eine Abgabe, die der Arbeitgeber auf Lohn und Leistungen an den Staat zahlt. Der Satz hängt davon ab, in welcher Zone (Kommune) das Unternehmen liegt — 14,1 % in Zone 1.',
  'pay.toAuthority': 'An Skatteetaten',
  'pay.toAuthorityHelp': 'Lohnsteuerabzug plus Arbeitgeberabgabe — der Gesamtbetrag, der für den Zeitraum an den Staat zu zahlen ist.',
  'pay.noPeriods': 'Noch keine Zeiträume',
  'pay.period2': 'Zeitraum',
  'pay.payrollRunShort': 'Lohnl.',
  'pay.pensionOtp': 'Pension / OTP',
  'pay.pensionOtpHelp': 'Die obligatorische betriebliche Altersversorgung (OTP) ist gesetzlich vorgeschriebenes Sparen für die Pension der Mitarbeitenden — mindestens 2 % des Lohns. Hier erfasst und verfolgst du die Einzahlungen an den Pensionsanbieter aus genehmigten Lohnläufen.',
  'pay.pensionPayments': 'Pensionseinzahlungen',
  'pay.pensionPaymentsSub': 'Erfasse und behalte die OTP-Zahlungen aus genehmigten Lohnläufen im Blick.',
  'pay.newPensionPayment': 'Neue Pensionseinzahlung',
  'pay.calculatedOtp': 'Berechnete OTP',
  'pay.calculatedOtpHelp': 'Insgesamt berechnete obligatorische betriebliche Altersversorgung für das Jahr aus genehmigten Lohnläufen.',
  'pay.open2': 'Offen',
  'pay.unpaid': 'Unbezahlt',
  'pay.unpaidOtpHelp': 'OTP, die berechnet, aber noch nicht an den Pensionsanbieter gezahlt wurde.',
  'pay.otp': 'OTP',
  'pay.paidOtpHelp': 'OTP, die bereits an den Pensionsanbieter eingezahlt wurde.',
  'pay.otpPaidWithDifference': 'Bezahlt {{paid}} · Differenz {{difference}}',
  'pay.noOtpBasis': 'Noch keine OTP-Grundlage',
  'pay.payPeriod': 'Lohnzeitraum',
  'pay.pensionPayment': 'Pensionseinzahlung',
  'pay.otpRefPh': 'z. B. OTP-06',
  'pay.holidayPayList': 'Urlaubsgeldliste',
  'pay.holidayPayListSub': 'Erworbenes und ausgezahltes Urlaubsgeld aus freigegebenen Lohnläufen.',
  'pay.holidayPayBasis': 'Urlaubsgeldgrundlage',
  'pay.earned': 'Erworben',
  'pay.noHolidayPay': 'Noch kein Urlaubsgeld',
  'pay.paymentDate': 'Auszahlungsdatum',
  'pay.holidayPayBasisHelp': 'Die Summe des Lohns, der Anspruch auf Urlaubsgeld gibt. Das Urlaubsgeld wird als Prozentsatz dieser Grundlage berechnet.',
  'pay.holidayPayEarnedHelp': 'Bisher erworbenes Urlaubsgeld — normalerweise 10,2 % der Grundlage (12 % bei fünf Wochen Urlaub). Wird im Jahr nach dem Erwerb ausgezahlt.',
  'pay.holidayPayPaidHelp': 'Urlaubsgeld, das in diesem Jahr bereits an Mitarbeitende ausgezahlt wurde.',
  'pay.voucherShort': 'Beleg:',
  'pay.paidOutShort': 'Ausgez.:',
  'pay.earnedShort': 'Erworben:',
  'pay.paidShort': 'Ausgezahlt:',
  'pay.salaryLine': 'Lohnzeile',
  'pay.newLine': 'Neue Zeile anlegen',
  'pay.taxResidentCountry': 'Steuerlich ansässig in Land',
  'pay.earningCountry': 'Land der Erwerbstätigkeit',
  'pay.earningRelation': 'Erwerbsverhältnis',
  'pay.noPrefill': 'Betrag/Menge für diese Zeile in neuen Lohnläufen nicht vorausfüllen',
  'pay.holidayPayPayout': 'Auszahlung von Urlaubsgeld',
  'pay.addHolidayPay': 'Urlaubsgeld hinzufügen',
  'pay.earnedEarlier': 'Früher erworben',
  'pay.earnedThisYear': 'In diesem Jahr erworben',
  'pay.pensionContribution': 'Beitrag/Prämie zur Pension',
  'pay.registerPensionContribution': 'Beitrag/Prämie zur Pension erfassen',
  'pay.fetchNavRefunds': 'Erstattungen von NAV abrufen',
  'pay.fetchNavRefundsSub': 'Erstattungen abrufen, die in den Lohnlauf übernommen werden sollen.',
  'pay.emailPayslips': 'Lohnabrechnungen per E-Mail senden',
  'pay.sendPayslips': 'Lohnabrechnungen senden',
  'pay.sendLater': 'Später senden',
  'pay.sendPayslip': 'Lohnabrechnung senden',
  'pay.sendAllPayslips': 'An alle senden',
  'pay.sending': 'Wird gesendet ...',
  'pay.payslipSendFailed': 'Lohnabrechnung konnte nicht gesendet werden.',
  'pay.payslipSendUnavailable': 'Der Versand von Lohnabrechnungen ist nicht mit dem Backend verbunden.',
  'pay.downloadPayslip': 'Lohnabrechnung herunterladen',
  'pay.downloadAllPdf': 'Alle herunterladen (PDF)',
  'pay.downloading': 'Wird heruntergeladen ...',
  'pay.sendTime': 'Versandzeitpunkt',
  'pay.payslipsAfterPosting': 'Lohnabrechnungen können heruntergeladen werden, sobald der Lohnlauf gebucht ist.',
  'pay.noPayslipsShort': 'Keine Lohnabrechnungen',
  'pay.paymentInfo': 'Informationen zur Auszahlung',
  'pay.copyToClipboard': 'In die Zwischenablage kopieren',
  'pay.downloadExcel': 'Excel herunterladen',
  'pay.registerPayment': 'Auszahlung erfassen',
  'pay.paymentsFromOperating': 'Auszahlungen vom Geschäftskonto:',
  'pay.toBankAccount': 'An Bankkonto',
  'pay.paidOutDate': 'Auszahlungsdatum',
  'pay.bankTip': 'Tipp! Vergiss nicht, die eigentliche Zahlung von Lohnsteuerabzug und Lohn im Onlinebanking auszuführen.',
  'pay.linkVoucher': 'Beleg verknüpfen',
  'pay.noInboxVouchers': 'Keine Belege im Posteingang',
  'pay.newSalaryLine': 'Neue Lohnzeile',
  'pay.paidOutVerb': 'Wird ausgezahlt',
  'pay.agaShort2': 'AGA',
  'pay.holiday': 'Urlaub',
  'pay.noExtraLines': 'Noch keine zusätzlichen Lohnzeilen hinzugefügt.',
  'pay.showEmployeePage': 'Mitarbeiterseite anzeigen',
  'pay.addSalaryLine': 'Lohnzeile hinzufügen',
  'pay.noEmployeesInRun': 'Keine Mitarbeitenden im Lohnlauf',
  'pay.holidayPensionDeductions': 'Urlaubsgeld, Pension und Abzüge',
  'pay.pensionContributionOrPremium': 'Beitrag oder Prämie zur Pension',
  'pay.summary': 'Zusammenfassung',
  'pay.payrollRun': 'Lohnlauf',
  'pay.agaRate': 'Arbeitgeberabgabe (14,1 %)',
  'pay.posting': 'Buchung',
  'pay.writeComment': 'Kommentar schreiben',
  'pay.seePayslips': 'Lohnabrechnungen ansehen',
  'pay.nextStep': 'Nächster Schritt',
  'pay.sendAmeldingToAltinn': 'A-melding an Altinn senden',
  'pay.deletePayrollRun': 'Lohnlauf löschen',
  'pay.manualSubmission': 'Manuelle Einreichung',
  'pay.sendAmelding': 'A-melding senden',
  'pay.altinnConfirmation': 'Bestätigung von Altinn',
  'pay.altinnConfirmationHelp': 'Nach dem Senden der A-melding wartest du auf die Bestätigung, bevor die Lohnabrechnungen erstellt werden.',
  'pay.createPayslips': 'Lohnabrechnungen erstellen',
  'pay.editPayrollRun': 'Lohnlauf bearbeiten',
  'pay.registerPaymentToEmployees': 'Zahlung an Mitarbeitende und Steuer erfassen',
  'pay.cancelPosting': 'Buchung stornieren',
  'pay.cancelPostingConfirmTitle': 'Buchung stornieren?',
  'pay.cancelPostingConfirmMessage': 'Dadurch wird der Lohnlauf wieder zum Entwurf. Erfasste Auszahlungen und die Buchung selbst werden storniert und aus den aktiven Buchhaltungszahlen entfernt. Du musst den Lohn erneut prüfen und freigeben.',
  'pay.cancelPostingConfirmAction': 'Buchung stornieren',
  'pay.keepPosting': 'Buchung behalten',
  'pay.seeAccountingVoucher': 'Buchungsbeleg ansehen',
  'pay.registerPayments': 'Auszahlungen erfassen',
  'pay.payrollDone': 'Der Lohn ist abgerechnet und gebucht!',
  'pay.payrollDoneSub': 'Der Lohnlauf ist eingereicht, gebucht und als ausgezahlt erfasst.',
  'pay.allPayrollRuns': 'Alle Lohnläufe',
  'pay.noEntries': 'Keine Buchungen',
  'pay.calculatedWithholding': 'Berechneter Lohnsteuerabzug',
  'pay.toPayOut': 'Zur Auszahlung',
  'pay.activePayrollRuns': 'Aktive Lohnläufe',
  'pay.runsCount': '{{count}} Läufe',
  'pay.employeesInActiveRuns': '{{count}} Mitarbeitende in aktiven Läufen',
  'pay.createNewRunHint': 'Lege einen neuen Lohnlauf an, um Mitarbeitende, feste Lohnzeilen und freigegebene Reisen zu übernehmen.',
  'pay.activePayrollRunsHelp': 'Ein Lohnlauf berechnet Lohn, Lohnsteuerabzug, Urlaubsgeld und Arbeitgeberabgabe für einen Zeitraum. Aktive Läufe sind in Bearbeitung.',
  'pay.newPayrollRun': 'Neuer Lohnlauf',
  'pay.noActiveRuns': 'Keine aktiven Lohnläufe',
  'pay.earlierPayrollRuns': 'Frühere Lohnläufe',
  'pay.earlierPayrollRunsHelp': 'Lohnläufe, deren Auszahlung erfasst ist. Du kannst sie für Details, Lohnabrechnungen und Buchungsbelege öffnen.',
  'pay.orderNumberDate': 'Neueste Auszahlung zuerst',
  'pay.travelAndExpenses': 'Reisen und Auslagen',
  'pay.createPayrollRun': 'Neuen Lohnlauf anlegen',
  'pay.payrollRunDate': 'Datum des Lohnlaufs',
  'pay.payPeriodMonthHelp': 'Der Monat, für den der Lohn gilt. Das Auszahlungsdatum kann ein anderes Datum sein.',
  'pay.paymentDateHelp': 'Das Datum, an dem das Geld tatsächlich ausgezahlt wird. Es ändert den Lohnzeitraum nicht.',
  'pay.paymentDatePeriodWarning': 'Das Auszahlungsdatum liegt außerhalb des üblichen Monats für den Lohnzeitraum. Prüfe, ob Lohnzeitraum und Datum korrekt sind.',
  'pay.includeFixedLines': 'Feste Lohnzeilen übernehmen',
  'pay.includeExpenseLines': 'Zeilen für Auslagen übernehmen',
  'pay.readyExpenseLineCount': '{count} Zeilen bereit zur Auszahlung',
  'pay.payPeriodLength': 'Lohnzeitraum (Erwerbsdauer)',
  'pay.ordinaryWithholding': 'Regulärer Lohnsteuerabzug',
  'pay.useTaxCard': 'Steuerkarte verwenden, wenn verfügbar',
  'pay.optionalComment': 'Optionaler Kommentar',
  'pay.salaryTypesAndDeductions': 'Lohnarten und Abzüge',
  'pay.salaryTypesHelp': 'Lohnarten steuern, wie eine Lohnzeile für AGA, Lohnsteuerabzug, Urlaubsgeld und Pension behandelt wird.',
  'pay.newSalaryType': 'Neue Lohnart',
  'pay.agaLiableHelp': 'Ob die Lohnart in die Grundlage der Arbeitgeberabgabe eingeht. Angehakt = abgabepflichtig.',
  'pay.withholdingLiableHelp': 'Ob die Lohnart abzugspflichtig ist — also ob vom Betrag Lohnsteuer einbehalten wird.',
  'pay.holidayPayLiableHelp': 'Ob die Lohnart Urlaubsgeldgrundlage ist — also ob auf den Betrag Urlaubsgeld erworben wird.',
  'pay.pension': 'Pension',
  'pay.pensionLiableHelp': 'Ob die Lohnart in die Grundlage der obligatorischen betrieblichen Altersversorgung (OTP) eingeht.',
  'pay.rules': 'Regeln',
  'pay.noLiabilityRules': 'Keine abgabe- oder abzugspflichtigen Regeln',
  'pay.noEffect': 'Keine Auswirkung',
  'pay.bonusExamplePh': 'z. B. Bonus ohne Urlaubsgeld',
  'pay.benefitInKind': 'Sachbezug',
  'pay.deduction': 'Abzug',
  'pay.taxFreeAllowance': 'Abzugsfreie Vergütung',
  'pay.overrideNote': 'Änderungen werden als Überschreibung der Standardart durch das Unternehmen gespeichert.',
  'pay.ratePerMonth': 'Satz (pro Monat)',
  'pay.calculated': 'Wird berechnet',
  'pay.changeCountries': 'Land der Erwerbstätigkeit/Ansässigkeit ändern',
  'pay.optionalCommentPh': 'Optionaler Kommentar ...',
  'pay.fixedSalaryLines': 'Feste Lohnzeilen',
  'pay.fixedSalaryLinesSub': 'Lohnzeilen, die sich in jedem Lohnlauf automatisch wiederholen.',
  'pay.addFixedLine': 'Feste Lohnzeile hinzufügen',
  'pay.noFixedLines': 'Keine festen Lohnzeilen',
  'pay.payrollSettings': 'Lohneinstellungen',
  'pay.payrollSettingsSub': 'Standardwerte, die Plumme beim Buchen von Lohn, Arbeitgeberabgabe, Urlaubsgeld und Pension verwendet.',
  'pay.contributionAndHoliday': 'Abgabe und Urlaubsgeld',
  'pay.agaZone': 'Zone der Arbeitgeberabgabe',
  'pay.holidayPayRate': 'Urlaubsgeldsatz',
  'pay.pensionOtpShort': 'Pension (OTP)',
  'pay.pensionProvider': 'Pensionsanbieter',
  'pay.providerOrgNo': 'Org.-Nr. des Anbieters',
  'pay.otpRate': 'OTP-Satz',
  'pay.accountsAndReporting': 'Konten und Meldungen',
  'pay.payrollAccount': 'Lohnkonto (Bank)',
  'pay.withholdingAccount': 'Steuerabzugskonto',
  'pay.firstPayrollYear': 'Erstes Jahr der Lohnbuchung',
  'pay.entityNumber': 'Betriebsnummer',
  'pay.holidayPayPercent': 'Urlaubsgeld in Prozent',
  'pay.holidayPayPercentHelp': 'Der Satz, mit dem Urlaubsgeld erworben wird. 10,2 % ist das gesetzliche Minimum; 12 % gilt bei vereinbarten fünf Wochen Urlaub.',
  'pay.holidayPayMonth': 'Monat für Urlaubsgeld',
  'pay.month.january': 'Januar',
  'pay.month.february': 'Februar',
  'pay.month.march': 'März',
  'pay.month.april': 'April',
  'pay.month.june': 'Juni',
  'pay.month.july': 'Juli',
  'pay.month.august': 'August',
  'pay.month.september': 'September',
  'pay.month.october': 'Oktober',
  'pay.month.november': 'November',
  'pay.month.december': 'Dezember',
  'pay.shift.none': 'Keine Schichtarbeit',
  'pay.shift.shift': 'Schichtarbeit',
  'pay.shift.rota': 'Turnusdienst',
  'pay.shift.continuous': 'Vollkontinuierliche Schichtarbeit',
  'pay.ordinary': 'Regulär',
  'pay.maritime': 'Seeschifffahrt',
  'pay.freelancer': 'Freiberufler',
  'pay.pensionOrOtherBenefit': 'Pension oder andere Leistung',
  'pay.municipalityAndNumber': 'Gemeinde und Gemeindenummer',
  'pay.pickMunicipality': 'Gemeinde wählen',
  'pay.calculationCode': 'Berechnungscode',
  'pay.generalIndustries': 'Allgemeine Branchen',
  'pay.agricultureForestry': 'Land- und Forstwirtschaft',
  'pay.fishing': 'Fischerei und Fang',
  'pay.pensionProviderOtp': 'Pensionsanbieter (OTP)',
  'pay.withholdingAccounts': 'Abzugskonten',
  'pay.payoutAccount': 'Konto für Lohnauszahlung',
  'pay.amelding': 'A-melding',
  'pay.everyMonth': 'Jeden Monat',
  'pay.everyPayrollRun': 'Bei jedem Lohnlauf',
  'pay.taxCardChangeAlert': 'Benachrichtigung bei Änderung der Steuerkarte',
  'pay.emailPh': 'name@firma.de',
  'pay.sms': 'SMS',
  'pay.savingsAccount': 'Sparkonto',
  'pay.withholdingMode.fiftyPercent': '50 % Lohnsteuerabzug',
  'pay.withholdingMode.standardHint': 'Verwendet die gültige Steuerkarte des Mitarbeitenden. Fehlt sie, werden 50 % abgezogen.',
  'pay.withholdingMode.taxCardHint': 'Steuerkarten werden noch nicht automatisch von Skatteetaten abgerufen. Plumme verwendet die beim Mitarbeitenden erfasste Steuerkarte und zieht 50 % ab, wenn keine gültige Steuerkarte vorliegt.',
  'pay.withholdingMode.fiftyPercentHint': 'Zieht 50 % der Abzugsgrundlage für alle Mitarbeitenden in diesem Lohnlauf ab, unabhängig von der Steuerkarte.',
  'pay.holidayPayPrevious.hint': 'Der im Vorjahr erworbene Betrag wird aus den genehmigten Lohnläufen des Vorjahres berechnet, abzüglich bereits ausgezahlter Beträge. Urlaubsgeld, das vor der Nutzung von Plumme erworben wurde, ist nicht enthalten – passe den Betrag mit dem Stift an.',
  'pay.deductionAccount.label': 'Konto, auf dem der Abzug gutgeschrieben wird',
  'pay.deductionAccount.hint': 'Abzüge, die an Dritte weitergezahlt werden, sind Verbindlichkeiten. Wähle 2610 für Lohnpfändung. Plumme meldet Lohnpfändungen nicht in der A-melding – der Abzug muss separat weitergezahlt werden.',
  'pay.deductionAccount.canteen': '5919 Abzug Kantinenkosten Mitarbeitende',
  'pay.deductionAccount.garnishment': '2610 Lohnpfändung',
  'pay.deductionAccount.unionDues': '2650 Einbehaltener Gewerkschaftsbeitrag',
  'pay.deductionAccount.other': '2690 Sonstige Abzüge',
  'pay.taxRuleUnsupportedError': 'Plumme unterstützt {rule} noch nicht – führe die Lohnabrechnung für {employee} außerhalb von Plumme durch.',
  'err.payroll.unsupportedTaxRule': 'Ein Mitarbeitender im Lohnlauf hat eine Steuer- und Abgabenregel, die Plumme noch nicht unterstützt. Führe die Lohnabrechnung für diesen Mitarbeitenden außerhalb von Plumme durch.',
  'pay.taxRules.svalbard': 'Svalbard',
  'pay.taxRules.janMayen': 'Jan Mayen und die Nebenländer',
  'pay.taxRules.seafarerDeduction': 'besonderer Abzug für Seeleute',
  'pay.taxRules.charity': 'gemeinnützige oder wohltätige Organisation',
  'pay.taxRules.netPay': 'Nettolohn',
  'pay.taxRules.netPaySeafarer': 'Nettolohn für Seeleute',
  'pay.taxRules.pensionSourceTax': 'Quellensteuer auf Pensionen',
  'pay.taxRules.nanny': 'Tagesmutter im Haushalt des Kindes',
  'pay.taxRules.homeWork': 'Lohnarbeit im Privathaushalt',
  'pay.taxRules.taxFreeOrganization': 'steuerbefreite Organisation',
  'pay.pensionAllocation.explain': 'Die Prämie ersetzt die berechnete OTP für die ausgewählten Mitarbeitenden. Wählst du mehrere, wird der Betrag nach ihrer OTP-Grundlage verteilt.',
  'pay.pensionAllocation.employees': 'Mitarbeitende, für die die Prämie gilt',
  'pay.pensionAllocation.amountRequired': 'Gib einen Betrag größer als 0 ein.',
  'pay.pensionAllocation.noEmployees': 'Wähle mindestens einen Mitarbeitenden, für den die Prämie gilt.',
  'pay.pensionAllocation.noBasis': 'Die ausgewählten Mitarbeitenden haben in diesem Lohnlauf keine OTP-Grundlage. Wähle einen Mitarbeitenden oder erfasse zuerst Lohn.',
  'pay.pensionAllocation.noLines': 'Der Lohnlauf enthält keine Mitarbeitenden, denen die Pensionsprämie zugeordnet werden kann.',
  'pay.pensionAllocation.saveFailed': 'Die Pensionsprämie konnte nicht erfasst werden.',
  'pay.travelNotPayableError': 'Diese Reisekostenabrechnungen oder Auslagen können in diesem Lohnlauf nicht mehr ausgezahlt werden: {travels}. Sie wurden bereits in einem anderen Lauf ausgezahlt oder sind nicht genehmigt. Entferne sie aus dem Entwurf oder storniere den Lauf, der sie ausgezahlt hat.',
  'err.payroll.travelNotPayable': 'Eine Reisekostenabrechnung oder Auslage im Lohnlauf wurde bereits in einem anderen Lauf ausgezahlt oder ist nicht mehr genehmigt. Entferne die Zeile aus dem Entwurf, bevor du genehmigst.',
  'pay.noCalculationBasis': 'Keine Berechnungsgrundlage',
  'pay.payTypeGroup.common': 'Häufige',
  'pay.payTypeGroup.custom': 'Eigene Lohnarten',
  'pay.payTypeGroup.other': 'Andere Lohnarten',
  'pay.payTypeGroup.benefitInKind': 'Sachbezüge',
  'pay.payTypeGroup.deduction': 'Abzüge',
  'pay.payTypeGroup.taxFreeAllowance': 'Abzugsfreie Vergütungen',
  'pay.inactive': 'inaktiv',
  'pay.selectSalaryType': 'Lohnart wählen',
  'pay.searchSalaryTypeOrRule': 'Nach Lohnart oder Regel suchen',
  'pay.showMoreSalaryTypes': 'Weitere Lohnarten anzeigen',
  'pay.calculationRules': 'Berechnungsregeln',
  'pay.agaAndTaxTab': 'Arbeitgeberabgabe und Steuer',
  'pay.pensionOtpTab': 'Pension/OTP',
  'pay.zone': 'Zone',
  'pay.status.paid': 'Bezahlt',
  'pay.status.unpaid': 'Nicht bezahlt',
  'pay.status.approved': 'Genehmigt',
  'pay.status.annulled': 'Storniert',
  'pay.status.draft': 'Entwurf',
  'pay.status.partiallyPaid': 'Teilweise bezahlt',
  'pay.select': 'Wählen',
  'pay.search': 'Suchen',
  'pay.noDataYet': 'Noch keine Daten',
  'pay.noDataYetBody': 'Sobald Einträge vorhanden sind, werden sie hier angezeigt.',
  'pay.notSet': 'Nicht festgelegt',
  'pay.thisIsADeduction': 'Dies ist ein Abzug',
  'pay.fixedLineHint.payout': 'Die Zeile wird an den Mitarbeitenden ausgezahlt',
  'pay.fixedLineHint.taxable': 'Abzugspflichtig - fließt in den Lohnsteuerabzug ein',
  'pay.fixedLineHint.employerContribution': 'Fließt in die Grundlage der Arbeitgeberabgabe ein',
  'pay.fixedLineHint.holidayPay': 'Fließt in die Urlaubsgeldgrundlage ein',
  'pay.fixedLineHint.pension': 'Fließt in die Grundlage für die Pension (OTP) ein',
  'pay.fixedLineHint.deduction': 'Negativer Betrag - wird von der Auszahlung abgezogen',
  'pay.amountMustBePositive': 'Der Betrag muss größer als 0 sein.',
  'pay.amountExceedsOpenTerm': 'Der Betrag darf nicht höher sein als der offene Betrag des Zeitraums.',
  'pay.allocationMustMatchAmount': 'Die Verteilung muss dem Betrag entsprechen und darf offene Beträge nicht überschreiten.',
  'pay.paymentUpdated': 'Zahlung aktualisiert.',
  'pay.paymentRegistered': 'Zahlung erfasst.',
  'pay.savePaymentFailed': 'Zahlung konnte nicht gespeichert werden.',
  'pay.paymentAnnulled': 'Zahlung storniert.',
  'pay.annulPaymentFailed': 'Zahlung konnte nicht storniert werden.',
  'pay.allPensionPaymentsRegistered': 'Alle Pensionszahlungen sind erfasst.',
  'pay.noOtpToRegisterYet': 'Noch keine berechnete OTP zum Erfassen.',
  'pay.missingPayrollRunForOtp': 'Für die OTP-Zahlung fehlt ein Lohnlauf.',
  'pay.pensionPaymentRegistered': 'Pensionszahlung erfasst.',
  'pay.registerPensionPaymentFailed': 'Pensionszahlung konnte nicht erfasst werden.',
  'pay.explainRuleOverrideRequired': 'Begründe, warum die Berechnungsregeln überschrieben werden.',
  'pay.navRefundsFetched': 'NAV-Erstattungen abgerufen.',
  'pay.navRefundsFetchFailed': 'Erstattungen von NAV konnten nicht abgerufen werden.',
  'pay.payslipDownloaded': 'Lohnabrechnung heruntergeladen.',
  'pay.payslipDownloadFailed': 'Lohnabrechnung konnte nicht heruntergeladen werden.',
  'pay.payslipsDownloaded': 'Lohnabrechnungen heruntergeladen.',
  'pay.payslipsDownloadFailed': 'Lohnabrechnungen konnten nicht heruntergeladen werden.',
  'pay.paymentInfoCopied': 'Auszahlungsinformationen kopiert.',
  'pay.paymentFileDownloaded': 'Auszahlungsdatei heruntergeladen.',
  'pay.linkInboxDocumentFailed': 'Beleg aus dem Posteingang konnte nicht verknüpft werden.',
  'pay.payrollRunCreated': 'Lohnauszahlung erstellt.',
  'pay.payrollRunCreateFailed': 'Lohnauszahlung konnte nicht erstellt werden.',
  'pay.payrollRunUpdateFailed': 'Lohnauszahlung konnte nicht aktualisiert werden.',
  'pay.deletedPayrollRunRemoved': 'Gelöschte Lohnauszahlung entfernt.',
  'pay.removePayrollRunFailed': 'Lohnauszahlung konnte nicht entfernt werden.',
  'pay.commentSaved': 'Kommentar gespeichert.',
  'pay.salaryLineAdded': 'Lohnzeile hinzugefügt.',
  'pay.voucherLinkedToPayrollRun': 'Beleg mit der Lohnauszahlung verknüpft.',
});
